export default "__VITE_ASSET__7857843c__"